export default __webpack_public_path__ + "images/0xaec9e50e3397f9ddc635c6c429c8c7eca418a143.png";